export function isComputerQuerySource(querySource) {
    return querySource === 'computer' || querySource === 'teammate_orchestrator';
}
//# sourceMappingURL=types.js.map